export default "__VITE_ASSET__LFN5_IsZ__"